import { useEffect } from "react";

const DEFAULT_TITLE = "A-Z Blinds | Premium Window Blinds Hyderabad";
const DEFAULT_DESCRIPTION = "A to Z Blinds Hyderabad – 35+ years of trusted blinds. Roller blinds, zebra blinds, vertical blinds, motorized blinds, PVC exterior & custom printed blinds. Free consultation, 3-day service. Contact for quotes.";
const DEFAULT_KEYWORDS = "blinds Hyderabad, window blinds Hyderabad, roller blinds, zebra blinds, vertical blinds, venetian blinds, motorized blinds, PVC exterior blinds, wooden blinds, bamboo blinds, custom blinds, A to Z Blinds, atozblinds, window coverings Hyderabad, made to measure blinds";

/**
 * Updates document title and meta description for the current page.
 * Call from each page component for per-route SEO.
 * @param {Object} options
 * @param {string} options.title - Page title (e.g. "About Us | A-Z Blinds")
 * @param {string} options.description - Meta description for the page
 * @param {string} [options.keywords] - Optional comma-separated keywords for this page
 */
export function useSEO({ title, description, keywords }) {
  useEffect(() => {
    const prevTitle = document.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    const prevDesc = metaDesc?.getAttribute("content");
    const prevKeywords = metaKeywords?.getAttribute("content");

    document.title = title || DEFAULT_TITLE;
    if (metaDesc) metaDesc.setAttribute("content", description || DEFAULT_DESCRIPTION);
    if (metaKeywords) metaKeywords.setAttribute("content", keywords || DEFAULT_KEYWORDS);

    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc) metaDesc.setAttribute("content", prevDesc);
      if (metaKeywords && prevKeywords) metaKeywords.setAttribute("content", prevKeywords);
    };
  }, [title, description, keywords]);
}
